import { action  } from "satcheljs";
import { IPreviewSchedulePageStore } from "../../../previewSchedulePage";
import { SchedulesViewStateStore } from "../store/schema/SchedulesViewStateStore";

const setIsProgressiveRendering = action(
    "SET_IS_PROGRESSIVE_RENDERING",
    (
        inProgress: boolean,
        didComplete: boolean = true,
        viewState?: IPreviewSchedulePageStore | SchedulesViewStateStore
    ) => ({
        inProgress: inProgress,
        didComplete: didComplete,
        viewState
    })
);

export default setIsProgressiveRendering;